<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="major w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/treasury" class="cl_gray">生涯宝库</router-link>  >  职业信息库</p>
				</div>
			</div>
			<div class="major_uni f18px cl_dark">
				<div class="major_ui_list" v-for="(item,index) in zhiye" :key="item.id" :class="{'on':index==currenCate}" @click="uniCheck(index)">{{item.name}}</div>
			</div>
			<div class="college">
				<div class="" v-if="currenCate==0">
					<div class="college_nav f16px cl_gray tc">
						<div class="college_nav_list bg_gray radius20" v-for="(item,index) in collegeList" :key="item.id" :class="{'on':index==currenCollege}" @click="collCheck(index)">{{item.name}}</div>
					</div>
					<div class="college_cont mat40" v-if="collegeList.length != 0">
						<div class="college_title f26px">{{collegeList[currenCollege].name}}</div>
						<div class="college_mid mat20">
							<img :src="collegeList[currenCollege].pic" class="college_mid_img" />
							<div class="college_mid_text f18px cl_dark">
								<p>{{collegeList[currenCollege].intro_1}}</p>
								<p class="mat10">{{collegeList[currenCollege].intro_2}}</p>
							</div>
						</div>
					</div>
					<div class="major_cont">
						<div class="major_item" v-for="(item,index) in majorCont" :key="index" v-if="item.post_data.length > 0">
							<div class="major_item_title f20px cl_dark" >{{item.name}}</div>
							<div class="major_item_cont">
								<div v-for="item in item.post_data" :key="item.id" class="major_item_list mab20">
									<router-link :to="{ path: '/treasury_details', query: { id: item.id, type: 2}}" class="inline cl_violet">
										<span class="inline mal5">{{item.name}}</span>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="career_hot" v-else>
					<div class="career_hot_list"  v-for="(item,index) in majorCate" :key="item.id" v-if="item.hot_post.length != 0">
						<div class="career_hot_list_title f20px">
							<img :src="item.pic" class="mar5" />
							<span>{{item.name}}</span>
						</div>
						<div class="career_hot_list_cont tc">
							<router-link class="cl_violet career_hot_list_item" :to="{ path: '/treasury_details', query: { id: item.id, type: 3}}" v-for="item in item.hot_post" :key="item.id">{{item.name}}</router-link>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'treasury_career',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 2,	//导航
				zhiye: [
					{
						id: 1,
						name: "职业信息宝库",
					},{
						id: 2,
						name: "热门职业精读",
					},
				],
				currenCate: 1,
				//热门
				majorCate: [],
				//职业
				collegeList: [],
				currenCollege: 0,
				majorCont: [],
				
			}
		},
		mounted() {
			
		},
		created() {
			if (this.$route.query.currenCate) {
				this.currenCate = this.$route.query.currenCate;
			}
			if (this.currenCate == 1) {
				this.getUni();
			} else {
				this.getColl()
			}
			
			
		},
		methods: {
			//热门
			getUni () {
				var that = this;
				that.$get("/api/careerbible/get_hot_post_list_data",{})
				.then(res => {
					that.majorCate = res.data;
				});
			},
			//职业
			getColl () {
				var that = this;
				that.$get("/api/careerbible/get_post_cate_data",{})
				.then(res => {
					that.collegeList = res.data;
					that.getCont();
				});
			},
			
			getCont () {
				var that = this;
				that.$get("/api/careerbible/get_post_list_data",{
					post_cate_id: that.collegeList[that.currenCollege].id,
				})
				.then(res => {
					that.majorCont = res.data;
				});
			},
			
			uniCheck (e) {
				this.currenCate = e;
				if (e == 1) {
					this.getUni();
				} else {
					this.getColl()
				}
			},
			collCheck (e) {
				this.currenCollege = e;
				this.getColl();
			},
		},
	}
</script>

<style>
</style>
